import { Component, OnInit } from '@angular/core';
import {Input} from '@angular/core';
import {_HttpClient} from '@delon/theme';
import {NzModalRef} from 'ng-zorro-antd';
import {SystemContants} from '@core/constants';

@Component({
  selector: 'app-review-log',
  templateUrl: './review-log.component.html',
  styles: []
})
export class ReviewLogComponent implements OnInit {

  @Input()
  record: any = {};
  histories: any[] = [];

  constructor(private http: _HttpClient, private ref: NzModalRef) { }

  ngOnInit() {
    this.loadHistories();
  }

  /**
   * 加载历史记录
   */
  loadHistories() {
    this.http.get<any>('api/app/approval/history/apply/'+this.record.id).subscribe((resp) => {
      if (resp.status === SystemContants.STATUS_SUCCESS) {
        this.histories = resp.data;
      }
    })
  }

  close() {
    this.ref.close();
  }






}
